// extracted by mini-css-extract-plugin
module.exports =  {"growthCreditsCell":"nJimFYagrxsOaTxxEf7K"};